"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.CHAT_STATUS = exports.MESSAGE_TYPES = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _Chat = _interopRequireDefault(require("./Chat.scss"));

var _MessagingService = _interopRequireDefault(require("../../../KESI2/Services/MessagingService"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _ChatMessage = _interopRequireDefault(require("./ChatMessage"));

var _ChatList = _interopRequireDefault(require("./ChatList"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _ChatInput = _interopRequireDefault(require("./ChatInput"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var MESSAGE_TYPES = {
  PRESENCE: 'presence',
  TEXT: 'text'
};
exports.MESSAGE_TYPES = MESSAGE_TYPES;
var CHAT_STATUS = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
  FINISHED: 'finished'
};
exports.CHAT_STATUS = CHAT_STATUS;

var Chat = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(Chat, _DataStoreComponent);

  var _super = _createSuper(Chat);

  function Chat(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, Chat);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePresenceList", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(channelName) {
        var presentUsersArray, presentUsers;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                presentUsersArray = [];
                _context.next = 3;
                return _MessagingService["default"].getPresence(channelName);

              case 3:
                presentUsers = _context.sent;
                presentUsers.forEach(function (userPresence) {
                  presentUsersArray.push(userPresence.data);

                  if (userPresence.data.isExpert && !_this.state.statusInitialized) {
                    if (userPresence.data.chatStatus === CHAT_STATUS.DEACTIVATED) {
                      _this.setState({
                        chatActive: false,
                        statusInitialized: true
                      });
                    } else if (userPresence.data.chatStatus === CHAT_STATUS.FINISHED) {
                      _this.setState({
                        chatFinished: true,
                        statusInitialized: true
                      });
                    }
                  }
                });

                _this.setState({
                  presenceList: presentUsersArray
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "download", function () {
      var textToDownload = '';
      var messages = [];

      var messageObjects = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES);

      if (messageObjects && messageObjects[_this.props.ablyChannel]) {
        messages = messageObjects[_this.props.ablyChannel];
      }

      if (messages.length > 0) {
        messages.forEach(function (message) {
          textToDownload += "".concat(_this.getDisplayedDate(message), " ").concat(message.userName ? "".concat(message.userName, ": ") : '').concat(message.quote ? "\n\"Zitat ".concat(message.quote.userName, ": ").concat(message.quote.text, "\"\n") : '').concat(message.text, "\n\n");
        });
        var currentDate = new Date();
        var year = currentDate.getFullYear();
        var month = currentDate.getMonth();
        var day = currentDate.getDay();
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(textToDownload));
        element.setAttribute('download', "expertenchat_".concat(year, "-").concat(month, "-").concat(day, ".txt"));
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendMessage", function (text) {
      console.log('[chat] sending message: ', text, _this.state.quotedMessage);

      _MessagingService["default"].sendMessage(_this.channel, 'message', {
        text: text,
        quote: _this.state.quotedMessage,
        userId: _this.state.userId,
        userName: _this.state.userName,
        date: new Date().toString(),
        isExpert: _this.state.isExpert,
        type: MESSAGE_TYPES.TEXT // channelName: this.props.ablyChannel

      });

      _this.resetQuotedMessage();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setQuotedMessage", function (message) {
      _this.setState({
        quotedMessage: message
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "resetQuotedMessage", function () {
      _this.setState({
        quotedMessage: null
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleChatActive", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var features, userData, userName, isExpert, userId, newStatus;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.FEATURES);

            case 2:
              features = _context2.sent;
              _context2.next = 5;
              return _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.USER_PROFILE);

            case 5:
              userData = _context2.sent;

              if (!features) {
                _context2.next = 23;
                break;
              }

              userName = 'Unbekannt';

              if (userData && userData.firstName) {
                userName = userData.firstName;
              } else {
                userName = features && features[_config["default"].requiredFeature] && features[_config["default"].requiredFeature].additionalData && features[_config["default"].requiredFeature].additionalData.firstname ? features[_config["default"].requiredFeature].additionalData.firstname : 'Unbekannt';
              }

              isExpert = features && (0, _keys["default"])(features).indexOf(_config["default"].kesiExpertFeatureName) !== -1;

              if (!(features && features[_config["default"].requiredFeature] && features[_config["default"].requiredFeature].userId)) {
                _context2.next = 14;
                break;
              }

              _context2.t0 = features[_config["default"].requiredFeature].userId;
              _context2.next = 17;
              break;

            case 14:
              _context2.next = 16;
              return _RegisterInstance["default"].getApplicationInstanceId();

            case 16:
              _context2.t0 = _context2.sent;

            case 17:
              userId = _context2.t0;
              newStatus = !_this.state.chatActive;

              _this.setState({
                chatActive: newStatus
              });

              console.log('setting new status to', newStatus);

              _MessagingService["default"].updatePresence(_this.props.ablyChannel, {
                nickname: userName,
                chatStatus: isExpert ? newStatus ? CHAT_STATUS.ACTIVE : CHAT_STATUS.DEACTIVATED : null,
                isExpert: isExpert,
                showOnlineState: true,
                userId: userId
              });

              _MessagingService["default"].sendMessage(_this.channel, 'expertStatusChange', {
                chatStatus: newStatus ? CHAT_STATUS.ACTIVE : CHAT_STATUS.DEACTIVATED
              });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleChatFinished", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var features, userData, userName, isExpert, userId, newStatus;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.FEATURES);

            case 2:
              features = _context3.sent;
              _context3.next = 5;
              return _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.USER_PROFILE);

            case 5:
              userData = _context3.sent;

              if (!features) {
                _context3.next = 24;
                break;
              }

              userName = 'Unbekannt';

              if (userData && userData.firstName) {
                userName = userData.firstName;
              } else {
                userName = features && features[_config["default"].requiredFeature] && features[_config["default"].requiredFeature].additionalData && features[_config["default"].requiredFeature].additionalData.firstname ? features[_config["default"].requiredFeature].additionalData.firstname : 'Unbekannt';
              }

              isExpert = features && (0, _keys["default"])(features).indexOf(_config["default"].kesiExpertFeatureName) !== -1;

              if (!(features && features[_config["default"].requiredFeature] && features[_config["default"].requiredFeature].userId)) {
                _context3.next = 14;
                break;
              }

              _context3.t0 = features[_config["default"].requiredFeature].userId;
              _context3.next = 17;
              break;

            case 14:
              _context3.next = 16;
              return _RegisterInstance["default"].getApplicationInstanceId();

            case 16:
              _context3.t0 = _context3.sent;

            case 17:
              userId = _context3.t0;
              newStatus = !_this.state.chatFinished;

              _this.setState({
                chatFinished: newStatus
              });

              _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.CHAT_FINISHED, ".").concat(_this.props.ablyChannel), newStatus);

              _KESI2Helper["default"].setFinishedChats(_this.props.ablyChannel, newStatus);

              _MessagingService["default"].updatePresence(_this.props.ablyChannel, {
                nickname: userName,
                chatStatus: isExpert ? newStatus ? CHAT_STATUS.FINISHED : _this.state.chatActive ? CHAT_STATUS.ACTIVE : CHAT_STATUS.DEACTIVATED : null,
                isExpert: isExpert,
                showOnlineState: true,
                userId: userId
              });

              _MessagingService["default"].sendMessage(_this.channel, 'expertStatusChange', {
                chatStatus: newStatus ? CHAT_STATUS.FINISHED : _this.state.chatActive ? CHAT_STATUS.ACTIVE : CHAT_STATUS.DEACTIVATED
              });

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    _this.state = {
      isConnecting: true,
      connectingError: null,
      userId: null,
      userName: null,
      isExpert: false,
      presenceList: null,
      quotedMessage: null,
      chatActive: true,
      chatFinished: false,
      statusInitialized: false
    };
    _this.channel = null; // will be initialized in connectToChatChannel

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Chat.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES, _DataStore.DATA_STORE_PATHS.CHAT_FINISHED, _DataStore.DATA_STORE_PATHS.CHAT_STATUS]);

    _this.loadAppInstanceId();

    return _this;
  }

  (0, _createClass2["default"])(Chat, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var messages, chatFinished, storePaths;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _DataStore["default"].getElementByPath("".concat(_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES, ".").concat(this.props.ablyChannel));

              case 2:
                messages = _context4.sent;
                _context4.next = 5;
                return _DataStore["default"].getElementByPath("".concat(_DataStore.DATA_STORE_PATHS.CHAT_FINISHED, ".").concat(this.props.ablyChannel));

              case 5:
                chatFinished = _context4.sent;
                console.log('chatFinished', chatFinished);

                if (chatFinished) {
                  console.log('chat is already finished, setting correct values');
                  this.setState({
                    chatActive: false,
                    chatFinished: true
                  });
                }

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CHAT_STATUS[this.props.ablyChannel], chatFinished ? CHAT_STATUS.FINISHED : CHAT_STATUS.ACTIVE);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.IN_CHAT, true);

                if (messages) {
                  this.setState({
                    messages: messages
                  });
                }

                storePaths = [];

                if (this.props.ablyChannel) {
                  storePaths.push("".concat(_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES, ".").concat(this.props.ablyChannel));
                  console.log('chat content', this.props.ablyChannel);
                }

                (0, _get2["default"])((0, _getPrototypeOf2["default"])(Chat.prototype), "setDataStorePaths", this).call(this, storePaths);
                this.connectToChatChannel();

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      var messageObjects = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES);

      var messages = messageObjects && messageObjects[this.props.ablyChannel] ? messageObjects[this.props.ablyChannel] : [];
      var leftChannel = [];
      var joinedChannel = [];

      if (prevState.presenceList && prevState.presenceList !== this.state.presenceList) {
        prevState.presenceList.forEach(function (user) {
          var userInNewList = _this2.state.presenceList.find(function (newUser) {
            return newUser.userId === user.userId;
          });

          if (!userInNewList) {
            console.log('user left', user);

            if (user.userId !== prevState.userId) {
              leftChannel.push({
                type: MESSAGE_TYPES.PRESENCE,
                date: new Date().toString(),
                text: user.isExpert ? "Experte ".concat(user.nickname, " hat den Chat verlassen, der Chat ist nun deaktiviert") : "".concat(user.nickname, " hat den Chat verlassen"),
                isExpert: user.isExpert
              });
            }
          } else {
            if (user.isExpert && user.chatStatus && userInNewList.chatStatus && user.chatStatus !== userInNewList.chatStatus) {
              console.log('expert changed status', userInNewList.chatStatus);

              if (userInNewList.chatStatus === CHAT_STATUS.ACTIVE) {
                leftChannel.push({
                  type: MESSAGE_TYPES.PRESENCE,
                  date: new Date().toString(),
                  text: "Experte ".concat(user.nickname, " hat den Chat aktiviert"),
                  isExpert: user.isExpert
                });

                _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.CHAT_FINISHED, ".").concat(prevProps.ablyChannel), false);
              } else if (userInNewList.chatStatus === CHAT_STATUS.FINISHED) {
                leftChannel.push({
                  type: MESSAGE_TYPES.PRESENCE,
                  date: new Date().toString(),
                  text: "Experte ".concat(user.nickname, " hat den Chat beendet"),
                  isExpert: user.isExpert
                });

                _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.CHAT_FINISHED, ".").concat(prevProps.ablyChannel), true);
              } else {
                leftChannel.push({
                  type: MESSAGE_TYPES.PRESENCE,
                  date: new Date().toString(),
                  text: "Experte ".concat(user.nickname, " hat den Chat deaktiviert"),
                  isExpert: user.isExpert
                });

                _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.CHAT_FINISHED, ".").concat(prevProps.ablyChannel), false);
              }
            }
          }
        });
        this.state.presenceList.forEach(function (user) {
          var userInOldList = prevState.presenceList.find(function (newUser) {
            return newUser.userId === user.userId;
          });

          if (!userInOldList) {
            console.log('user joined', user);

            if (user.userId !== prevState.userId) {
              joinedChannel.push({
                type: MESSAGE_TYPES.PRESENCE,
                date: new Date().toString(),
                text: user.isExpert ? "Experte ".concat(user.nickname, " hat den Chat betreten") : "".concat(user.nickname, " hat den Chat betreten"),
                isExpert: user.isExpert
              });
            }
          }
        });
        messages = messages.concat(leftChannel).concat(joinedChannel);

        _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES, ".").concat(this.props.ablyChannel), messages);
      }

      if (prevState.data[_DataStore.DATA_STORE_PATHS.CHAT_STATUS] && this.state.data[_DataStore.DATA_STORE_PATHS.CHAT_STATUS] && prevState.data[_DataStore.DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] && this.state.data[_DataStore.DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] && prevState.data[_DataStore.DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] !== this.state.data[_DataStore.DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel]) {
        if (this.state.data[_DataStore.DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] === CHAT_STATUS.ACTIVE) {
          this.state.chatActive = true;
          this.state.chatFinished = false;
        } else if (this.state.data[_DataStore.DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] === CHAT_STATUS.DEACTIVATED) {
          this.state.chatActive = false;
          this.state.chatFinished = false;
        } else {
          this.state.chatActive = false;
          this.state.chatFinished = true;
        }
      }
    }
    /*
    componentWillUpdate (nextProps, nextState) {
      const messageObjects = DataStore.getElementByPathImmediately(DATA_STORE_PATHS.CHAT_MESSAGES)
      let messages = messageObjects && messageObjects[this.props.ablyChannel] ? messageObjects[this.props.ablyChannel] : []
       const leftChannel = []
      const joinedChannel = []
       if (this.state.presenceList && this.state.presenceList !== nextState.presenceList) {
        this.state.presenceList.forEach(user => {
          const userInNewList = nextState.presenceList.find(newUser => newUser.userId === user.userId)
          if (!userInNewList) {
            console.log('user left', user)
            if (user.userId !== this.state.userId) {
              leftChannel.push({
                type: MESSAGE_TYPES.PRESENCE,
                date: new Date().toString(),
                text: user.isExpert ? `Experte ${user.nickname} hat den Chat verlassen, der Chat ist nun deaktiviert` : `${user.nickname} hat den Chat verlassen`,
                isExpert: user.isExpert
              })
            }
          }
          else {
            if (user.isExpert && user.chatStatus && userInNewList.chatStatus && user.chatStatus !== userInNewList.chatStatus) {
              console.log('expert changed status', userInNewList.chatStatus)
              if (userInNewList.chatStatus === CHAT_STATUS.ACTIVE) {
                leftChannel.push({
                  type: MESSAGE_TYPES.PRESENCE,
                  date: new Date().toString(),
                  text: `Experte ${user.nickname} hat den Chat aktiviert`,
                  isExpert: user.isExpert
                })
                DataStore.setSingleData(`${DATA_STORE_PATHS.CHAT_FINISHED}.${this.props.ablyChannel}`, false)
              }
              else if (userInNewList.chatStatus === CHAT_STATUS.FINISHED) {
                leftChannel.push({
                  type: MESSAGE_TYPES.PRESENCE,
                  date: new Date().toString(),
                  text: `Experte ${user.nickname} hat den Chat beendet`,
                  isExpert: user.isExpert
                })
                DataStore.setSingleData(`${DATA_STORE_PATHS.CHAT_FINISHED}.${this.props.ablyChannel}`, true)
              }
              else {
                leftChannel.push({
                  type: MESSAGE_TYPES.PRESENCE,
                  date: new Date().toString(),
                  text: `Experte ${user.nickname} hat den Chat deaktiviert`,
                  isExpert: user.isExpert
                })
                DataStore.setSingleData(`${DATA_STORE_PATHS.CHAT_FINISHED}.${this.props.ablyChannel}`, false)
              }
            }
          }
        })
        nextState.presenceList.forEach(user => {
          const userInOldList = this.state.presenceList.find(newUser => newUser.userId === user.userId)
          if (!userInOldList) {
            console.log('user joined', user)
            if (user.userId !== this.state.userId) {
              joinedChannel.push({
                type: MESSAGE_TYPES.PRESENCE,
                date: new Date().toString(),
                text: user.isExpert ? `Experte ${user.nickname} hat den Chat betreten` : `${user.nickname} hat den Chat betreten`,
                isExpert: user.isExpert
              })
            }
          }
        })
        messages = messages.concat(leftChannel).concat(joinedChannel)
        DataStore.setSingleData(`${DATA_STORE_PATHS.CHAT_MESSAGES}.${this.props.ablyChannel}`, messages)
      }
      console.log('component did update', this.state.data[DATA_STORE_PATHS.CHAT_STATUS], nextState.data[DATA_STORE_PATHS.CHAT_STATUS])
      if (this.state.data[DATA_STORE_PATHS.CHAT_STATUS] && nextState.data[DATA_STORE_PATHS.CHAT_STATUS]
        && nextState.data[DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] && this.state.data[DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel]
        && this.state.data[DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] !== nextState.data[DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel]) {
        console.log('updated chat status to', nextState.data[DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel])
         if (nextState.data[DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] === CHAT_STATUS.ACTIVE) {
          nextState.chatActive = true
          nextState.chatFinished = false
        }
        else if (nextState.data[DATA_STORE_PATHS.CHAT_STATUS][this.props.ablyChannel] === CHAT_STATUS.DEACTIVATED) {
          nextState.chatActive = false
          nextState.chatFinished = false
        }
        else {
          nextState.chatActive = false
          nextState.chatFinished = true
        }
      }
    }
    */

  }, {
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.IN_CHAT, false);

              case 2:
                _MessagingService["default"].leavePresence(this.props.ablyChannel, {
                  nickname: this.state.userName,
                  showOnlineState: true,
                  userId: this.state.userId
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "getDisplayedDate",
    value: function getDisplayedDate(message) {
      var date = message && message.date ? new Date(message.date) : new Date();
      var hours = date.getHours();

      if (hours < 10) {
        hours = "0".concat(hours);
      }

      var minutes = date.getMinutes();

      if (minutes < 10) {
        minutes = "0".concat(minutes);
      }

      return "".concat(hours, ":").concat(minutes);
    }
  }, {
    key: "connectToChatChannel",
    value: function () {
      var _connectToChatChannel = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var _this3 = this;

        var features, userData, userName, isExpert, userId;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _MessagingService["default"].getChannel(this.props.ablyChannel, true);

              case 3:
                this.channel = _context6.sent;
                _context6.next = 6;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.FEATURES);

              case 6:
                features = _context6.sent;
                userData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.USER_PROFILE);

                if (!(features && features[_config["default"].requiredFeature])) {
                  _context6.next = 23;
                  break;
                }

                userName = 'Unbekannt';

                if (userData && userData.firstName) {
                  userName = userData.firstName;
                } else {
                  userName = features && features[_config["default"].requiredFeature] && features[_config["default"].requiredFeature].additionalData && features[_config["default"].requiredFeature].additionalData.firstname ? features[_config["default"].requiredFeature].additionalData.firstname : 'Unbekannt';
                }

                isExpert = features && (0, _keys["default"])(features).indexOf(_config["default"].kesiExpertFeatureName) !== -1;

                if (!(features && features[_config["default"].requiredFeature] && features[_config["default"].requiredFeature].userId)) {
                  _context6.next = 16;
                  break;
                }

                _context6.t0 = features[_config["default"].requiredFeature].userId;
                _context6.next = 19;
                break;

              case 16:
                _context6.next = 18;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 18:
                _context6.t0 = _context6.sent;

              case 19:
                userId = _context6.t0;

                _MessagingService["default"].enterPresence(this.props.ablyChannel, {
                  nickname: userName,
                  chatStatus: isExpert ? this.state.chatActive ? this.state.chatFinished ? CHAT_STATUS.FINISHED : CHAT_STATUS.ACTIVE : CHAT_STATUS.DEACTIVATED : null,
                  isExpert: isExpert,
                  showOnlineState: true,
                  userId: userId
                });

                _MessagingService["default"].subscribePresence(this.props.ablyChannel, function () {
                  return _this3.updatePresenceList(_this3.props.ablyChannel);
                });

                this.updatePresenceList(this.props.ablyChannel);

              case 23:
                _context6.next = 25;
                return (0, _TimeoutHelper.timeout)(200);

              case 25:
                this.setState({
                  isConnecting: false
                });
                _context6.next = 32;
                break;

              case 28:
                _context6.prev = 28;
                _context6.t1 = _context6["catch"](0);
                console.error('error connecting to chat channel', _context6.t1);
                this.setState({
                  isConnecting: false,
                  connectingError: (0, _ErrorHelper.getErrorMessage)(_context6.t1)
                });

              case 32:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 28]]);
      }));

      function connectToChatChannel() {
        return _connectToChatChannel.apply(this, arguments);
      }

      return connectToChatChannel;
    }()
  }, {
    key: "loadAppInstanceId",
    value: function () {
      var _loadAppInstanceId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var features, userData, userName, isExpert, userId, _userName, _isExpert, _userId;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.FEATURES);

              case 2:
                features = _context7.sent;
                _context7.next = 5;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.USER_PROFILE);

              case 5:
                userData = _context7.sent;
                console.log('chat', userData, features[_config["default"].requiredFeature]);

                if (!(userData && (0, _keys["default"])(userData).length > 0)) {
                  _context7.next = 22;
                  break;
                }

                userName = userData.firstName ? userData.firstName : 'Unbekannt';
                isExpert = features && (0, _keys["default"])(features).indexOf(_config["default"].kesiExpertFeatureName) !== -1;

                if (!(features && features[_config["default"].requiredFeature] && features[_config["default"].requiredFeature].userId)) {
                  _context7.next = 14;
                  break;
                }

                _context7.t0 = features[_config["default"].requiredFeature].userId;
                _context7.next = 17;
                break;

              case 14:
                _context7.next = 16;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 16:
                _context7.t0 = _context7.sent;

              case 17:
                userId = _context7.t0;
                console.log('loadAppInstanceId', userName);
                this.setState({
                  userName: userName,
                  userId: userId,
                  isExpert: isExpert
                });
                _context7.next = 43;
                break;

              case 22:
                if (!(features && features[_config["default"].requiredFeature] && (!userData || (0, _keys["default"])(userData).length === 0))) {
                  _context7.next = 37;
                  break;
                }

                _userName = features[_config["default"].requiredFeature].additionalData && features[_config["default"].requiredFeature].additionalData.firstname ? features[_config["default"].requiredFeature].additionalData.firstname : 'Unbekannt';
                _isExpert = features && (0, _keys["default"])(features).indexOf(_config["default"].kesiExpertFeatureName) !== -1;

                if (!(features && features[_config["default"].requiredFeature] && features[_config["default"].requiredFeature].userId)) {
                  _context7.next = 29;
                  break;
                }

                _context7.t1 = features[_config["default"].requiredFeature].userId;
                _context7.next = 32;
                break;

              case 29:
                _context7.next = 31;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 31:
                _context7.t1 = _context7.sent;

              case 32:
                _userId = _context7.t1;
                console.log('loadAppInstanceId', _isExpert);
                this.setState({
                  userName: _userName,
                  userId: _userId,
                  isExpert: _isExpert
                });
                _context7.next = 43;
                break;

              case 37:
                _context7.t2 = this;
                _context7.next = 40;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 40:
                _context7.t3 = _context7.sent;
                _context7.t4 = {
                  userName: 'Unbekannt',
                  userId: _context7.t3,
                  isExpert: false
                };

                _context7.t2.setState.call(_context7.t2, _context7.t4);

              case 43:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function loadAppInstanceId() {
        return _loadAppInstanceId.apply(this, arguments);
      }

      return loadAppInstanceId;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var channelId = this.props.ablyChannel;
      var messages = [];

      var messageObjects = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES);

      if (messageObjects && messageObjects[this.props.ablyChannel]) {
        messages = messageObjects[this.props.ablyChannel];
      }

      if (this.state.isConnecting) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "Verbindung wird zu ", channelId, " aufgebaut");
      }

      if (this.state.connectingError) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "Verbindung zu ", channelId, " konnte nicht aufgebaut werden. Grund:", /*#__PURE__*/_react["default"].createElement("p", null, this.state.connectingError));
      }

      var messagesToRender = messages.map(function (message, index) {
        var key = "chat_".concat(channelId, "_").concat(index);
        return /*#__PURE__*/_react["default"].createElement(_ChatMessage["default"], {
          id: key,
          userId: _this4.state.userId,
          key: key,
          message: message,
          isLatest: index === messages.length - 1,
          isExpert: _this4.state.isExpert,
          setQuotedMessage: _this4.setQuotedMessage
        });
      });
      var expertOnline = this.state.presenceList ? this.state.presenceList.find(function (user) {
        return user.isExpert === true;
      }) : _config["default"].isDemo; // const chatActive = expertOnline && expertOnline.chatStatus === CHAT_STATUS.ACTIVE

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: this.state.isExpert ? {} : {
          paddingBottom: '50px'
        },
        className: _Chat["default"].chat
      }, /*#__PURE__*/_react["default"].createElement(_ChatList["default"], null, messagesToRender.length > 0 ? messagesToRender : this.props.info ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '100%',
          textAlign: 'center'
        },
        dangerouslySetInnerHTML: {
          __html: this.props.info
        }
      }) : 'Keine Nachrichten vorhanden'), this.state.chatActive && (expertOnline || this.state.isExpert || _config["default"].isDemo || _config["default"].enableChatWithoutExpert) && /*#__PURE__*/_react["default"].createElement(_ChatInput["default"], {
        sendMessageFn: this.sendMessage,
        quotedMessage: this.state.quotedMessage,
        resetQuotedMessage: this.resetQuotedMessage
      }), messagesToRender.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        onClick: this.download,
        className: _Chat["default"].downloadContainer
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "download",
        className: _Chat["default"].downloadButton
      }), 'Download Protokoll') : null, this.state.isExpert ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Chat["default"].chatToggleContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Chat["default"].chatToggle
      }, /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
        checked: this.state.chatActive,
        onChange: this.toggleChatActive,
        classes: {
          colorSecondary: this.state.chatActive ? _Chat["default"].switchColors : _Chat["default"].switchColorsDeactivated,
          bar: this.state.chatActive ? _Chat["default"].barColor : _Chat["default"].barColorDeactivated
        },
        disabled: this.state.chatFinished
      }), 'Chatteilnehmer dürfen Nachrichten schreiben'), this.state.isExpert && !this.state.chatActive ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Chat["default"].chatToggle
      }, /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
        checked: this.state.chatFinished,
        onChange: this.toggleChatFinished,
        classes: {
          colorSecondary: this.state.chatFinished ? _Chat["default"].switchColors : _Chat["default"].switchColorsDeactivated,
          bar: this.state.chatFinished ? _Chat["default"].barColor : _Chat["default"].barColorDeactivated
        }
      }), 'Chat ist beendet') : null) : null);
    }
  }]);
  return Chat;
}(_DataStoreComponent2["default"]);

Chat.propTypes = {
  ablyChannel: _propTypes["default"].string.isRequired,
  info: _propTypes["default"].string
};
var _default = Chat;
exports["default"] = _default;